"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRaceList = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Returns a list of all races.
 *
 * ### Filter options
 *
 * - `type` - filters by race type,
 * - `season` - filters by race season.
 *
 * ### Sort options
 *
 * - `startDate` - sorts by race starting date,
 * - `endDate` - sorts by race ending date,
 * - `season` - sorts races by season.
 *
 * ## Usage
 *
 * ```ts
 * const racesAll: Race[] = await sdk.getRaceList({ });
 * const racesNewest: Race[] = await sdk.getRaceList({ sort: { startDate: 'desc' }});
 * const racesSeasonThree: Race[] = await sdk.getRaceList({ filter: { season: '5afe4378dde74c68 }});
 * ```
 *
 * @param params.filter - Filter to apply to returned race list.
 * @param params.sort - Fields to sort race list by.
 * @param params.limit - How many races will get returned.
 * ```
 *
 */
const getRaceList = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { filter, sort, limit } = params;
    const url = `${BASE_URL}/races/list`;
    const raceResponse = yield axios_1.default.post(url, { filter, sort, limit }, { validateStatus: () => true });
    const { status, data } = raceResponse;
    if (status !== 200)
        throw new Error(data.error);
    return data;
});
exports.getRaceList = getRaceList;
